<template>
  <div>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-form v-on:submit.prevent="addItem" v-model="valid" ref="dustForm">
            <v-layout row wrap>
                <v-flex xs6>
                  <v-img src="img/Dust.jpg" aspect-ratio="1.7"></v-img>
                </v-flex>
                <v-flex xs6 class="card-item">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        name="weigth"
                        label="Peso (Kg)"
                        id="weigth"
                        v-model="itemData.weigth"
                        outline
                        @focus="$event.target.select()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="Price"
                        label="Precio"
                        id="price"
                        type="number"
                        v-model="itemData.price_per_kilo"
                        @focus="$event.target.select()"
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        item-text="label"
                        item-value="value"
                        :items="dustDieselOptions"
                        v-model="itemData.is_diesel"
                        label="¿Es diesel?"
                        outline
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn type="submit" color="success">Agregar</v-btn>
                </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dustDieselOptions: [
        {label: 'No', value: 'NO'},
        {label: 'Si', value: 'YES'},
      ],
      defaultItemData: {
        weigth: 0,
        price_per_kilo: 0.00,
        is_diesel: 'NO',
        type: 'DUST',
      },
      itemData: {
        weigth: 0,
        price_per_kilo: 0.00,
        is_diesel: 'NO',
        type: 'DUST',
      },
      valid: true,
    };
  },
  computed: {
  },
  methods: {
    addItem() {
      if (this.isLineValid()) {
        this.itemData.weigth = parseFloat(this.itemData.weigth);
        this.itemData.price_per_kilo = parseFloat(this.itemData.price_per_kilo);

        this.$emit('add-item', this.itemData);
        this.itemData = Object.assign({}, this.defaultItemData);
      } else {
        this.$emit('warning', 'Ingrese el peso');
      }
    },
    isLineValid() {
      return this.itemData.weigth > 0;
    },
  },
};
</script>